import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import UpgradeButton from './UpgradeButton';
import Icon from './AppIcon';
import { useSubscription } from '../hooks/useSubscription';

const UpgradeBanner = ({ compact = false }) => {
  const { profile } = useAuth();

  // Only show for free users
  const { tier } = useSubscription();

  if ((tier && tier !== 'free') || (profile?.subscription_tier && profile.subscription_tier !== 'free')) {
    return null;
  }

  if (compact) {
    return (
      <div className="bg-gradient-to-r from-primary/10 to-accent/10 rounded-lg p-4 border border-primary/20">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/20 flex items-center justify-center flex-shrink-0">
              <Icon name="Zap" size={20} color="var(--color-primary)" />
            </div>
            <div>
              <h4 className="text-sm font-semibold text-foreground">Unlock Full Access</h4>
              <p className="text-xs text-muted-foreground">Get unlimited drills & AI coaching</p>
            </div>
          </div>
          <UpgradeButton plan="pro" size="sm">
            Upgrade
          </UpgradeButton>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-r from-primary/5 via-accent/5 to-primary/5 rounded-xl p-6 border border-primary/20 mb-6">
      <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
        <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-primary to-accent flex items-center justify-center flex-shrink-0">
          <Icon name="Zap" size={28} color="#FFFFFF" />
        </div>
        <div className="flex-1">
          <h3 className="text-lg font-bold text-foreground mb-1">
            🚀 Unlock Your Full Sales Potential
          </h3>
          <p className="text-sm text-muted-foreground mb-3">
            Get unlimited access to AI coaching, advanced drills, objection mastery, and personalized feedback
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-muted-foreground">
            <div className="flex items-center gap-1.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
              <span>Unlimited AI coaching</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
              <span>Advanced objection handling</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
              <span>Real-time feedback</span>
            </div>
            <div className="flex items-center gap-1.5">
              <Icon name="Check" size={14} color="var(--color-success)" />
              <span>Performance analytics</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-2 w-full md:w-auto">
          <UpgradeButton plan="pro" size="lg" fullWidth>
            Upgrade to Pro
          </UpgradeButton>
          <UpgradeButton plan="elite" variant="outline" size="sm" fullWidth>
            View Elite Plan
          </UpgradeButton>
        </div>
      </div>
    </div>
  );
};

export default UpgradeBanner;
